export const METRICS_CONSTANT ={
    GQL_API_NAME : {
        GET_DELIVERY_DETAILS : "GetDeliveryDetails",
        GET_DELIVERY_SUMMARY : "GetDeliverySummary",
        RESCHEDULE_DELIVERIES: "RescheduleDeliveries",
        CONFIGURATION_SERVICE: "ConfigurationService",
        SEARCH_VEHICLE_API: "SearchVehicleAPI",
        GET_VEHICLE_API: "GetVehicleAPI",
        GET_STOP_API: "GetStopAPI",
        GET_CONTAINER_BY_STOP_API: "GetContainerByStopAPI",
        GET_PLANNER_AUDIT_HISTORY: "GetPlannerAuditHistory",
        GET_SHIPPING_REQUEST: "GetShippingRequest",
        UPLOAD_DOCUMENTS: "UploadDocuments",
        GET_DOCUMENT_DETAILS: "GetDocumentDetails"
    },
    METHOD_NAME: {
        PLANNED_DELIVERIES: "PlannedDeliveries",
        DELIVERIES_SUMMARY: "DeliveriesSummary",
        HUB_SUMMARY: "HubSummary",
        CABLING_MANIFEST: "CablingManifest",
        UPDATE_CONFIGURATION_DATA: "UpdateConfigurationData",
        GET_CONFIGURATION_DATA: "GetConfigurationData",
        DMS_SEARCH_PAGE: "DmsSearchPage",
        DMS_SITE_CONTAINER_LOAD_PAGE: "DmsSiteContainerLoadPage",
        DMS_SITE_CONTAINER_SUMMARY_PAGE: "DmsSiteContainerSummaryPage",
        DMS_DETAIL_PAGE: "DmsDetailPage",
        PLANNER_AUDIT_HISTORY: "PlannerAuditHistory",
        SHIPMENT_AUDIT_HISTORY: "ShipmentAuditHistory",
        UPLOAD_DOCUMENTS: "UploadDocuments",
        DOCUMENT_DETAILS: "DocumentDetails"
    },
    CUSTOM_METRIC_NAME: {
        PLANNER_AUDIT_HISTORY_MAPPING: "PlannerAuditHistoryMapping",
        SHIPMENT_AUDIT_HISTORY_MAPPING: "ShipmentAuditHistoryMapping",
    }
}